import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Dashboard = lazy(() => import('./Dashboard'));

const DashboardRoute: FuseRouteItemType = {
	path: '/dashboard',
	element: <Dashboard />
};

export default DashboardRoute;
